<!-- Analytics Dashboard -->
@if (isMaster) {
  <div class="analytics-dashboard">
    <div class="v-card">
      <div class="card report-header list-header list-header-fixed flex-row justify-content-between align-items-center pe-4 ps-4">
        <div class="d-flex">
          <div class="header fs-20 font-weight-700 pt-1 me-2">{{ 'MAIN.ANALYTICS.TITLE' | translate }}</div>
        </div>
      </div>
      <!-- Tab Area -->
      <div class="card tab-area d-flex flex-row first-area">
        <div class="tab-item left fs-16 font-weight-600 ms-4" [ngClass]="{'selected-tab' : tabIndex == 0 }" (click)="onDashboardTab()">
          <span class="tab-title">{{ 'MAIN.ANALYTICS.DASHBOARD' | translate }}</span>
        </div>
        <div class="tab-item right fs-16 font-weight-600 ms-4" [ngClass]="{'selected-tab' : tabIndex == 1 }" (click)="onUsageTab()">
          <span class="tab-title">{{ 'MAIN.ANALYTICS.USAGE' | translate }}</span>
        </div>
      </div>
      <!-- Dashboard Tab Content -->
      @if (tabIndex == 0) {
        <div class="tab-content-wrapper">
          <!-- Loading State -->
          @if (loading) {
            <div class="loader">
              <div class="spinner"></div>
            </div>
          }
          <!-- Dashboard Stats -->
          @if (!loading && stats) {
            <div class="dashboard-content">
              <!-- Total Stats Cards -->
              <div class="stats-overview">
                <mat-card class="stat-card">
                  <mat-card-title>{{ stats.total_workflows }}</mat-card-title>
                  <mat-card-subtitle>{{ 'MAIN.ANALYTICS.TOTAL_WORKFLOWS' | translate }}</mat-card-subtitle>
                </mat-card>
                <mat-card class="stat-card">
                  <mat-card-title>{{ stats.total_shared_workflows }}</mat-card-title>
                  <mat-card-subtitle>{{ 'MAIN.ANALYTICS.TOTAL_SHARED_WORKFLOWS' | translate }}</mat-card-subtitle>
                </mat-card>
                <mat-card class="stat-card">
                  <mat-card-title>{{ stats.total_users }}</mat-card-title>
                  <mat-card-subtitle>{{ 'MAIN.ANALYTICS.TOTAL_USERS' | translate }}</mat-card-subtitle>
                </mat-card>
                <mat-card class="stat-card">
                  <mat-card-title>{{ stats.total_submissions }}</mat-card-title>
                  <mat-card-subtitle>{{ 'MAIN.ANALYTICS.TOTAL_SUBMISSIONS' | translate }}</mat-card-subtitle>
                </mat-card>
              </div>
              <!-- Child Accounts Breakdown -->
              @if (stats.child_stats?.length > 0) {
                <mat-card class="stats-table">
                  <mat-card-header>
                    <mat-card-title>{{ 'MAIN.ANALYTICS.CHILD_ACCOUNTS_BREAKDOWN' | translate }}</mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <table mat-table [dataSource]="stats.child_stats">
                      <ng-container matColumnDef="account_name">
                        <th mat-header-cell *matHeaderCellDef>{{ 'MAIN.ANALYTICS.ACCOUNT' | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.account_name }}</td>
                      </ng-container>
                      <ng-container matColumnDef="workflow_count">
                        <th mat-header-cell *matHeaderCellDef style="text-align: right;">{{ 'MAIN.ANALYTICS.WORKFLOWS' | translate }}</th>
                        <td mat-cell *matCellDef="let row" style="text-align: right;">{{ row.workflow_count }}</td>
                      </ng-container>
                      <ng-container matColumnDef="shared_workflow_count">
                        <th mat-header-cell *matHeaderCellDef style="text-align: right;">{{ 'MAIN.ANALYTICS.SHARED' | translate }}</th>
                        <td mat-cell *matCellDef="let row" style="text-align: right;">{{ row.shared_workflow_count }}</td>
                      </ng-container>
                      <ng-container matColumnDef="user_count">
                        <th mat-header-cell *matHeaderCellDef style="text-align: right;">{{ 'MAIN.ANALYTICS.USERS' | translate }}</th>
                        <td mat-cell *matCellDef="let row" style="text-align: right;">{{ row.user_count }}</td>
                      </ng-container>
                      <ng-container matColumnDef="submission_count">
                        <th mat-header-cell *matHeaderCellDef style="text-align: right;">{{ 'MAIN.ANALYTICS.SUBMISSIONS' | translate }}</th>
                        <td mat-cell *matCellDef="let row" style="text-align: right;">{{ row.submission_count }}</td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="['account_name', 'workflow_count', 'shared_workflow_count', 'user_count', 'submission_count']"></tr>
                      <tr mat-row *matRowDef="let row; columns: ['account_name', 'workflow_count', 'shared_workflow_count', 'user_count', 'submission_count']"></tr>
                    </table>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          }
        </div>
      }
      <!-- Usage Tab Content -->
      @if (tabIndex == 1) {
        <div class="tab-content-wrapper">
          <!-- Date Filter -->
          <div class="date-filter">
            <input #filterDates="bsDaterangepicker"
              name="filterDates"
              [(ngModel)]="filterStartEnd"
              class="filter-input fs-14 ms-0"
              bsDaterangepicker
              placeholder="Select Date Range"
              [bsConfig]="{ rangeInputFormat: 'DD-MM-YYYY', containerClass: 'theme-blue', customTodayClass: 'datepicker-today' }"
              (ngModelChange)="onDateRangeChange()"
              onkeypress="return false;"
              style="min-width: 220px;">
            @if (filterStartEnd?.length > 0) {
              <button
                (click)="clearDateFilters()"
                class="btn btn-sm btn-outline-secondary ms-2"
                style="height: 32px; font-size: 12px;"
                title="Clear date filter">
                ✕
              </button>
            }
          </div>
          <!-- Loading State -->
          @if (loading) {
            <div class="loader">
              <div class="spinner"></div>
            </div>
          }
          <!-- Stats Cards -->
          @if (!loading && stats) {
            <div class="stats-overview">
              <mat-card class="stat-card">
                <mat-card-title>{{ stats.workflow_stats?.length || 0 }}</mat-card-title>
                <mat-card-subtitle>{{ 'MAIN.ANALYTICS.SHARED_WORKFLOWS' | translate }}</mat-card-subtitle>
              </mat-card>
              <mat-card class="stat-card">
                <mat-card-title>{{ stats.child_stats?.length || 0 }}</mat-card-title>
                <mat-card-subtitle>{{ 'MAIN.ANALYTICS.ACTIVE_DOMAINS' | translate }}</mat-card-subtitle>
              </mat-card>
              <mat-card class="stat-card">
                <mat-card-title>{{ stats.total_completions }}</mat-card-title>
                <mat-card-subtitle>{{ 'MAIN.ANALYTICS.TOTAL_COMPLETIONS' | translate }}</mat-card-subtitle>
              </mat-card>
            </div>
          }
          <!-- Child Account Stats -->
          @if (!loading && stats && stats.child_stats?.length > 0) {
            <mat-card class="stats-table">
              <mat-card-content>
                <table mat-table [dataSource]="stats.child_stats">
                  <ng-container matColumnDef="account_name">
                    <th mat-header-cell *matHeaderCellDef>{{ 'MAIN.ANALYTICS.DOMAIN' | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.account_name }}</td>
                  </ng-container>
                  <ng-container matColumnDef="completions">
                    <th mat-header-cell *matHeaderCellDef style="text-align: right;">{{ 'MAIN.ANALYTICS.SUBMISSIONS' | translate }}</th>
                    <td mat-cell *matCellDef="let row" style="text-align: right;">{{ row.completions }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="['account_name', 'completions']"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['account_name', 'completions']"></tr>
                </table>
              </mat-card-content>
            </mat-card>
          }
          <!-- Workflow Stats -->
          @if (!loading && stats && stats.workflow_stats?.length > 0) {
            <mat-card class="stats-table">
              <mat-card-content>
                <table mat-table [dataSource]="stats.workflow_stats">
                  <ng-container matColumnDef="workflow_name">
                    <th mat-header-cell *matHeaderCellDef>{{ 'MAIN.ANALYTICS.WORKFLOW' | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.workflow_name }}</td>
                  </ng-container>
                  <ng-container matColumnDef="completions">
                    <th mat-header-cell *matHeaderCellDef style="text-align: right;">{{ 'MAIN.ANALYTICS.SUBMISSIONS' | translate }}</th>
                    <td mat-cell *matCellDef="let row" style="text-align: right;">{{ row.completions }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="['workflow_name', 'completions']"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['workflow_name', 'completions']"></tr>
                </table>
              </mat-card-content>
            </mat-card>
          }
        </div>
      }
    </div>
  </div>
}

<!-- Not Master -->
@if (!isMaster && !loading) {
  <div class="not-available">
    <p>{{ 'MAIN.ANALYTICS.NOT_AVAILABLE' | translate }}</p>
  </div>
}
